import { FC, useCallback } from 'react';
import { useField } from 'formik';

import Autocomplete, { AutocompleteProps } from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';

type Props = Omit<
  AutocompleteProps<string, true, false, true>,
  'options' | 'renderOption' | 'filterOptions' | 'renderInput'
> & {
  name: string;
  label?: string;
};

const ChipInput: FC<Props> = props => {
  const { name, label, placeholder, ...rest } = props;
  const [{ value }, , { setValue }] = useField<string[]>(name);

  const handleChange = useCallback(
    (_, inputValue: any[]) => {
      setValue(inputValue);
    },
    [setValue]
  );

  return (
    <Autocomplete
      multiple
      freeSolo
      options={[]}
      value={value}
      onChange={handleChange}
      renderTags={(value, getTagProps) =>
        value.map((tag, index) => (
          <Chip label={tag} {...getTagProps({ index })} />
        ))
      }
      renderInput={params => (
        <TextField
          {...params}
          variant="standard"
          label={label}
          placeholder={placeholder}
        />
      )}
      {...rest}
    />
  );
};

export default ChipInput;
